module.exports = __webpack_public_path__ + "img/numbered_list.2baeb559.svg";